import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import { POPPINS } from "./dashboardTypography";

export const CHART_PALETTE = [
  "#2563EB",
  "#EF4444",
  "#10B981",
  "#F59E0B",
  "#8B5CF6",
  "#EC4899",
  "#06B6D4",
  "#F97316",
  "#84CC16",
  "#E11D48",
  "#14B8A6",
  "#7C3AED",
];

export const AXIS_TICK_STYLE = {
  fill: "#64748B",
  fontSize: 11,
  fontWeight: 500,
};

export const GRID_STYLE = {
  strokeDasharray: "3 3",
  stroke: "#E2E8F0",
};

export const formatChartNumber = (num) => {
  const numeric = Number(num);
  if (Number.isNaN(numeric)) return "N/A";
  if (Math.abs(numeric) >= 1000000000) return `${(numeric / 1000000000).toFixed(2)}B`;
  if (Math.abs(numeric) >= 1000000) return `${(numeric / 1000000).toFixed(2)}M`;
  if (Math.abs(numeric) >= 1000) return `${(numeric / 1000).toFixed(1)}K`;
  if (Number.isInteger(numeric)) return numeric.toLocaleString();
  return numeric.toFixed(2);
};

export const DashboardChartTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;

  return (
    <Box
      sx={{
        p: 1.5,
        borderRadius: "10px",
        boxShadow: "0 8px 24px rgba(2, 8, 20, 0.14)",
        background: "rgba(255, 255, 255, 0.98)",
        border: "1px solid rgba(15, 23, 42, 0.08)",
        minWidth: 170,
      }}
    >
      <Typography variant="subtitle2" sx={{ ...POPPINS, mb: 0.5, fontWeight: 700, color: "#1E293B", fontSize: 12.5 }}>
        {label}
      </Typography>
      {payload.map((entry) => (
        <Box key={entry.name} sx={{ display: "flex", alignItems: "center", mt: 0.35 }}>
          <Box
            sx={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              background: entry.color,
              mr: 0.8,
              flexShrink: 0,
            }}
          />
          <Typography variant="body2" sx={{ ...POPPINS, color: "#475569", fontSize: 11.5, mr: 0.6 }}>
            {entry.name}:
          </Typography>
          <Typography variant="body2" sx={{ ...POPPINS, fontWeight: 600, color: "#0F172A", fontSize: 11.5 }}>
            {formatChartNumber(entry.value)}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

DashboardChartTooltip.propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.array,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

DashboardChartTooltip.defaultProps = {
  active: false,
  payload: [],
  label: "",
};
